'use client';

import dynamic from 'next/dynamic';

export const GatedContent = dynamic(() => import('./GatedContent'));
